module.exports = __webpack_public_path__ + "static/media/communityWitness.6369d28b.webp";